import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Form, Button, Icon, Input } from "antd";
import { sendNotification } from "../../utils/index";
import { userChangePassword } from "../../actions/AuthAction";
import { PasswordInput } from "antd-password-input-strength";

export class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      password: "",
      confirm: "",
      isEnabled: false,
      inputColorNew: "#eaeaea",
      inputColorConfirm: "#eaeaea",
      rol: " ",
    };
  }

  componentDidMount() {
    const { user, clientRole, role } = this.props;

    this.setState({
      rol:
        role === "admin" && clientRole === "admin"
          ? "Súper admin"
          : clientRole === "admin"
          ? "Administrador"
          : "Operador",
      name: user ? user.name : "",
    });
  }

  componentDidUpdate(prevProps) {
    const { changePassword, intl } = this.props;
    if (
      prevProps.changePassword !== changePassword &&
      changePassword === "success"
    ) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "password_changed_success" })
      );
      this.props.close();
    } else if (
      prevProps.changePassword !== changePassword &&
      changePassword === "error"
    ) {
      sendNotification("error", intl, intl.formatMessage({ id: "try_again" }));
    }
  }

  handleOnInputChange = (e) => {
    const { password, confirm } = this.state;
    this.setState({
      [e.target.name]: e.target.value,
      isEnabled: password !== "" && confirm !== "",
    });
  };

  handleSubmit = (e) => {
    const { name, password, confirm } = this.state;
    const { intl } = this.props;

    e.preventDefault();

    if (name.trim() === "") {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "must_enter_name" })
      );
      return;
    }

    if (password !== confirm) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "password_confirmation" })
      );
      return;
    }

    this.props.userChangePassword(name, password);
  };

  handleCancel = () => {
    this.props.close();
  };

  render() {
    const { name, password, confirm, isEnabled, rol } = this.state;
    const { user, isFetching, newColor, intl, force } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} layout="vertical">
        <Form.Item>
          {/* <span><b>{intl.formatMessage({ id: "name" })}:</b> {user.name} </span><br /> */}
          <span>
            <b>Email:</b> {user.email}{" "}
          </span>
          <br />
          <span>
            <b>{intl.formatMessage({ id: "role" })}:</b> {rol}
          </span>
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "name" })}</span>
          <Input
            name="name"
            value={name}
            placeholder={intl.formatMessage({ id: "name" })}
            onChange={this.handleOnInputChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "new_password" })}</span>
          <PasswordInput
            name="password"
            type="password"
            value={password}
            placeholder={intl.formatMessage({ id: "new_password" })}
            onChange={this.handleOnInputChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "confirm_new_password" })}</span>
          <PasswordInput
            name="confirm"
            type="password"
            value={confirm}
            placeholder={intl.formatMessage({ id: "confirm_new_password" })}
            onChange={this.handleOnInputChange}
          />
        </Form.Item>
        <Form.Item>
          {!isEnabled && (
            <Button
              loading={isFetching}
              type="primary"
              htmlType="submit"
              disabled={!isEnabled}
            >
              {intl.formatMessage({ id: "change_password" })}
            </Button>
          )}
          {isEnabled && (
            <Button
              loading={isFetching}
              type="primary"
              style={{ backgroundColor: newColor, borderColor: newColor }}
              htmlType="submit"
              disabled={!isEnabled}
            >
              {intl.formatMessage({ id: "change_password" })}
            </Button>
          )}
          {!force && (
            <Button
              type="default"
              style={{
                color: newColor,
                borderColor: newColor,
                marginLeft: "10px",
              }}
              onClick={this.handleCancel}
            >
              {intl.formatMessage({ id: "cancel_button" })}
              <Icon type="close" />
            </Button>
          )}
        </Form.Item>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authUser.user,
    isFetching: state.authUser.changePasswordIsFetching,
    changePassword: state.authUser.changePassword,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    clientRole: state.authUser.user.clientRole,
    role: state.authUser.user.role,
  };
};

const mapDispatchToProps = {
  userChangePassword,
};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ChangePassword)
  )
);
